var render = function render(){var _vm=this,_c=_vm._self._c;return ((_vm.curData.CompID || _vm.curData.CompId) && _vm.productLogo)?_c('img',{staticClass:"vip-level-icon",attrs:{"width":_vm.width,"height":_vm.height || _vm.width,"src":_vm.productLogo}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }